<template>
    <div class="detail_body">
      <div class="zhanghu">
        <div class="tupian"><img src="/lanse.jpg"></div>
        <div class="zichan">余额(元)</div>
        <div class="yue">¥{{jine}}</div>
      </div>

      <div class="beij"></div>

      <div class="mingxi">明细</div>

      <div class="lingqian" v-for="item in list">
<!--        <div class="tu"><img src="/6.jpeg"></div>-->
        <div class="zi">
          <div style="color: #333333;font-size: 14px;">{{item.contents}}</div>
          <div style="color: #ccc;">{{item.addtime}}</div>
        </div>
        <div class="jine" v-if="item.types==1">+¥{{item.changes}}</div>
        <div class="jine" v-if="item.types==2">-¥{{item.changes}}</div>
      </div>


    </div>
</template>

<script>
    export default {
        name: "detail",
        data(){
            return{
                list:[],
                jine:''
            }
        },
        created() {
            this.getdata()

        },
      // this.myrequest({
      //   url:'/client/getmyinfo.action',
      //   types:'get',
      //   data:{
      //     // token:this.$store.state.token
      //   },
      //   succ: (res) => {
      //
      //     this.touxiang=res.data.avatar
      //     console.log(res,213)
      //     this.mingzi=res.data.nickname
      //     this.dizhi=res.data.address
      //     this.shouji=res.data.mobile
      //     console.log(res.data.mobile,122)
      //     this.jine=res.data.fee
      //
      //   },
      //   errs: (msg) => {
      //
      //   }
      // })
        methods:{
            getdata() {
                this.myrequest({
                    url:'/client/getfeelist.action',
                    types:'get',
                    data:{
                        // token:this.$store.state.token
                    },
                    succ: (res) => {
                        this.list=res.data
                        this.jine=res.fee
                    },
                    errs: (msg) => {

                    }
                })
            },
        }
    }
</script>

<style scoped lang="stylus">
  .detail_body{
    width 100%;
    .lingqian{
      width 95%;
      margin 10px auto;
      border-bottom 1px solid #f5f5f5;
      height 50px;
      .tu{
        float left;
        /*margin-top 10px;*/
        img{
          width 40px;
          height 40px;
          border-radius 20px;
        }
      }
      .zi{
        float left;
        margin-left 10px;
        /*margin-top 15px;*/
      }
      .jine{
        float right;
        /*margin-top 20px;*/
        color #333333;
        font-weight 500;
        font-size 14px;
        margin-right 10px;
      }
    }
    .beij {

      background-color #fafafa;
      width 100%;
      height 10px;
      margin-top 20px;
    }
    .zhanghu {
      position relative;
      width 95%;
      margin 10px auto;

      .tupian {
        width 100%;

        img {
          width 100%;
          height 150px;
          border-radius 10px;
        }
      }

      .zichan {
        position absolute
        top 30%;
        left 40%;
        font-size 16px;
        color #ffffff;
        font-weight 500
      }

      .yue {
        position absolute
        top 45%;
        left 41%;
        font-size 14px;
        color #ffffff;
        font-weight 500
      }
    }
    .mingxi{
      width 90%;
      margin 10px auto;
      font-size 16px;
      color #ccc;
      font-weight 500
    }

  }

</style>



// WEBPACK FOOTER //
// src/components/wode/detail.vue